var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex_nowrap align-items_top item",style:({background: _vm.no_bg ? 'unset' : ''})},[_c('span',{staticClass:"color_gray"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"margin_left_10 right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }